import { StudioEndpoints } from '@floori-web/interfaces';

export const studioEndpoints = {
    account: {
        login: 'v3/studio/account/login',
    },
    company: {
        vendorId: 'v3/studio/account/vendor-id/:subdomain',
        config: 'v3/studio/account/config',
        configDetails: 'v3/studio/account/config/details',
        ctaButtons: 'v3/studio/account/cta-buttons',
    },
    rooms: {
        baseRooms: 'v3/studio/room',
        createRoom: 'v3/studio/room/:visitorId',
    },
    room: {
        arLinks: 'v3/studio/visualization/ar-links/:variantId',
        questions: 'v3/studio/visualization/product-queston',
        estimation: 'v3/studio/visualization/estimation',
        session: 'v3/studio/visualization/session',
        quote: 'v3/studio/visualization/quote',
        addToCart: 'v3/studio/product/cart',
        gallery: 'v3/studio/visualization/product/:productId/gallery',
    },
    product: {
        breadcrumb: 'v3/studio/explore/product/breadcrumbs/:productId',
        filters: 'v3/studio/visualization/product-filters',
        filterProducts: 'v3/studio/explore/filters',
        product: 'v3/studio/explore',
        boostRender: 'v3/studio/visualization/boost-render',
    },
} satisfies StudioEndpoints;
